import type { QuickPanelMessage } from "../quickPanel.types";
import { toAnaliseEstoqueExcelMessage } from "../utils/quickPanelParsers";
import { useQuickPanelSocketEvent } from "./useQuickPanelSocketEvent";

// --------------------------------- TYPES ---------------------------------
type UseQuickPanelExcelEventParams = {
	readonly onMessages: (messages: QuickPanelMessage[]) => void;
	readonly enabled?: boolean;
};

// ---------------------------------- HOOK ----------------------------------
export function useQuickPanelExcelEvent({ onMessages, enabled = true }: UseQuickPanelExcelEventParams): void {
	useQuickPanelSocketEvent({
		event: "analise_estoque_excel:pronto",
		parse: toAnaliseEstoqueExcelMessage,
		onMessages,
		enabled,
	});
}
